// React
import { create } from 'zustand';

// Utils
import { createClient } from '@/utils/supabase/client';
import toast from 'react-hot-toast';

// Libraries


interface UserState {
  loading: boolean;
  user: any | null;
  role: string | null;
  supabase: any;
  setLoading: (loading: boolean) => void;
  setUser: (user: any) => void;
  setRole: (role: string | null) => void;
  loadUser: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const useUserStore = create<UserState>((set, get) => ({
  loading: false,
  user: null,
  role: null,
  supabase: createClient(),

  setLoading: (loading) => set({ loading }),
  setUser: (user) => set({ user }),
  setRole: (role) => set({ role }),

  loadUser: async () => {
    const { supabase, setLoading, setUser, setRole } = get();
    setLoading(true);
    try {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (error) {
        toast.error("Error getting user data:", error.message);
        setUser(null);
        setRole(null);
      } else {
        setUser(user);

        const { data: roleData, error: roleError } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user?.id)
          .single();

        if (roleError) {
          toast.error("Error fetching user role:", roleError.message);
          setRole(null);
        } else {
          setRole(roleData?.role);
        }
      }
    } catch (err) {
      toast.error(`Error while checking login: , ${err}`);
    }
    setLoading(false);
  },

  signOut: async () => {
    const { supabase } = get();
    await supabase.auth.signOut();
  },
}));
